 document.addEventListener("DOMContentLoaded", function() {
   var currentUrl = window.location.pathname;
    console.log(currentUrl);

    if (currentUrl === '/pages/contact-us-1/1000') {
     window.location.href = 'https://rosewoman.com/pages/contact-us-1';
   }
    else if(currentUrl === '/pages/subscriptions/1000'){
      window.location.href = 'https://rosewoman.com/pages/subscriptions';
   }
   else if(currentUrl === '/pages/faq/1000'){
      window.location.href = 'https://rosewoman.com/pages/faq';
   }
   else if (currentUrl === '/collections/cart-upsells/products/holiday-gift-trio-of-soaps'){
      window.location.href = 'https://rosewoman.com/products/holiday-gift-trio-of-soaps';
   }
   else if (currentUrl === '/collections/lavender/products/holiday-gift-trio-of-soaps'){
      window.location.href = 'https://rosewoman.com/products/holiday-gift-trio-of-soaps';
   }
    else if (currentUrl === '/collections/rosemary/products/holiday-gift-trio-of-soaps'){
      window.location.href = 'https://rosewoman.com/products/holiday-gift-trio-of-soaps';
   }
    else if (currentUrl === '/collections/hygeine/products/holiday-gift-trio-of-soaps'){
      window.location.href = 'https://rosewoman.com/products/holiday-gift-trio-of-soaps';
   }
   else if (currentUrl === '/collections/all/products/body-love-journal'){
      window.location.href = 'https://rosewoman.com/products/body-love-journal';
   }
    else if (currentUrl === '/collections/test-collection/products/body-gua-sha'){
      window.location.href = 'https://rosewoman.com/products/body-gua-sha';
   }
    else if (currentUrl === '/collections/all/products/body-gua-sha'){
      window.location.href = 'https://rosewoman.com/products/body-gua-sha';
   }
   else if (currentUrl === '/collections/test-collection/products/heart-kanna-gummies'){
      window.location.href = 'https://rosewoman.com/products/heart-kanna-gummies';
   }
    else if (currentUrl === '/pages/for-healthcare-professionals/1000'){
      window.location.href = 'https://rosewoman.com/pages/for-healthcare-professionals';
   }
   else if (currentUrl === '/collections/prenatal-and-postpartum/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
   else if (currentUrl === '/collections/orange-peel-extract/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
    else if (currentUrl === '/collections/all/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
    else if (currentUrl === '/collections/vanilla-orchid/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
   else if (currentUrl === '/collections/neroli-bitter-orange-oil/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
  else if (currentUrl === '/collections/memorial-weekend-collection/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
   else if (currentUrl === '/collections/lemon/products/soothe-calming-cream-refresh-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream-refresh-cleansing-wipes';
   }
   else if (currentUrl === '/collections/buy-with-prime/products/honor-regenerating-balm'){
      window.location.href = 'https://rosewoman.com/products/honor-regenerating-balm';
   }
   else if (currentUrl === '/collections/memorial-weekend-collection/products/gift-card'){
      window.location.href = 'https://rosewoman.com';
   }
   else if (currentUrl === '/collections/test-collection/products/maui-super-herbs-akala-tincture'){
      window.location.href = 'https://rosewoman.com/products/maui-super-herbs-akala-tincture';
   }
   else if (currentUrl === '/collections/subscribe-and-save/products/travel-sample-set'){
      window.location.href = 'https://rosewoman.com/products/travel-sample-set';
   }
   else if (currentUrl === '/collections/2021-holiday-gift-guide/products/body-gua-sha' || currentUrl === '/collections/most-popular/products/body-gua-sha'){
      window.location.href = 'https://rosewoman.com/products/body-gua-sha';
   }
   else if (currentUrl === '/collections/golden-and-silver-honeysuckle/products/refresh-intimate-and-body-cleansing-wipes'){
      window.location.href = 'https://rosewoman.com/products/refresh-intimate-and-body-cleansing-wipes';
   }
   else if (currentUrl === '/collections/chafing/products/soothe-calming-cream'){
      window.location.href = 'https://rosewoman.com/products/soothe-calming-cream';
   }
   else if (currentUrl === '/collections/pre-post-natal'){
      window.location.href = 'https://rosewoman.com/collections/prenatal-and-postpartum';
   }
   else if (currentUrl === '/collections/dryness/products/arouse-stimulating-serum'){
      window.location.href = 'https://rosewoman.com/products/arouse-stimulating-serum';
   }
   else if (currentUrl === '/collections/massage/products/anoint-nourishing-body-oil'){
      window.location.href = 'https://rosewoman.com/products/anoint-nourishing-body-oil';
   }
   else if (currentUrl === '/collections/sacred-lovings'){
     window.location.href = 'https://rosewoman.com/collections/loving-unions';
   }
   else if(currentUrl === '/collections/menopause/products/arouse-stimulating-serum'){
     window.location.href = 'https://rosewoman.com/products/arouse-stimulating-serum';
   }
   else if(currentUrl === '/collections/lifestyle/products/limited-edition-exfoliating-gardners-soap'){
     window.location.href = 'https://rosewoman.com/products/limited-edition-exfoliating-gardners-soap';
   }
   else if(currentUrl === '/collections/all/products/duos'){
     window.location.href = 'https://rosewoman.com';
   }
   else if(currentUrl === '/collections/peppermint/products/soothe-calming-cream-bundle'){
      window.location.href = 'https://rosewoman.com';
   }
   else if(currentUrl === '/collections/peppermint/products/travel-size-of-soothe-calming-cream'){
      window.location.href = 'https://rosewoman.com';
   }
   else if(currentUrl === '/blogs/perspectives/truly-caring-for-yourself-in-the-new-year-8-unusual-resolutions'){
     window.location.href = 'https://rosewoman.com';
   }
   else if(currentUrl === '/@rosebudwoman'){
     window.location.href = 'https://rosewoman.com';
   }
   else if(currentUrl === '/collections/sunflower/products/wholesale-travel-size-of-honor-everyday-balm'){
     window.location.href = 'https://rosewoman.com';
   }
   else if(currentUrl === '/pages/weddinggiftguidewip00000000'){
     window.location.href = 'https://rosewoman.com/pages/wedding-gift-guide-wip';
   }
   else if (currentUrl === '/collections/most-popular/products/travel-size-honor-everyday-balm') {
      window.location.href = 'https://rosewoman.com/products/travel-size-honor-everyday-balm';
    }
    else if (currentUrl === '/collections/loving-unions/products/travel-sample-set') {
      window.location.href = 'https://rosewoman.com/products/travel-sample-set';
    }
    else if (currentUrl === '/collections/all/products/winter-skin-essentials') {
      window.location.href = 'https://rosewoman.com/products/winter-skin-essentials';
    }
    else if (currentUrl === '/collections/wellness/products/anoint-gift-set') {
      window.location.href = 'https://rosewoman.com/products/anoint-gift-set';
    }
    else if (currentUrl === '/collections/all/products/friends-with-benefits') {
      window.location.href = 'https://rosewoman.com/products/friends-with-benefits';
    }
    else if (currentUrl === '/collections/test-collection/products/new-ambassador-welcome-kit') {
      window.location.href = 'https://rosewoman.com/products/new-ambassador-welcome-kit';
    }
    else if (currentUrl === '/collections/loving-unions/products/friends-with-benefits') {
      window.location.href = 'https://rosewoman.com/products/friends-with-benefits';
    }
    else if (currentUrl === '/products/reverence-gift-box') {
      window.location.href = 'https://rosewoman.com'
    }
    else if(currentUrl === '/collections/wellness/products/ease-hawaiian-kava-gummies') {
      window.location.href = 'https://rosewoman.com/products/ease-hawaiian-kava-gummies'
    }
    else if (currentUrl === '/collections/all/products/the-nine-gifts-first-aid-for-mind-body-and-spirit') {
      window.location.href = 'https://rosewoman.com/products/the-nine-gifts-first-aid-for-mind-body-and-spirit'
    }
    else if (currentUrl === '/collections/loving-unions/products/the-ritual-the-complete-set') {
      window.location.href = 'https://rosewoman.com/products/the-ritual-the-complete-set'
    }
    else if(currentUrl === '/collections/all/products/the-ritual-the-complete-set') {
       window.location.href = 'https://rosewoman.com/products/the-ritual-the-complete-set'
    }
    else if (currentUrl === '/collections/all/products/ease-hawaiian-kava-gummies') {
      window.location.href = 'https://rosewoman.com/products/ease-hawaiian-kava-gummies'
    }
 });